import { uniqueId } from '@/components/home/Contents'
import { assets } from '@/helpers/common'
import { domAnimation, LazyMotion, m } from 'framer-motion'

function TermsConditionBanner() {
  return (
    <section className={`with-banner bg-white-ice-three section-spacing--small`}>
      <div className='main-banner'>
        <div className='container mx-auto relative desktop-banner'>
          <div className='row justify-center'>
            <div className='w-5/12 md-mx:w-4/12 text-right'>
              <img className='inline-block' src={assets('images/terms-and-conditions.png')} alt={''} />
            </div>
            <div className='w-7/12 md-mx:w-8/12 text-left flex items-center pl-10 md-mx:pl-3'>
              <LazyMotion features={domAnimation}>
                <m.div
                  key={uniqueId('animation-')}
                  animate={{ scale: 1, y: 0, opacity: 1 }}
                  transition={{ duration: 0.7 }}
                  initial={{ scale: 0.8, y: 100, opacity: 0 }}
                >
                  <div className='banner-content text-center'>
                    <h1 className='text-4xl2 sm-mx:text-2xl font-bold text-secondary mb-4'>Terms and Conditions</h1>
                  </div>
                </m.div>
              </LazyMotion>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default TermsConditionBanner
